import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { textTruncate } from "../../styles";
import { vars } from "../../styles/theme.css";

export const chipBaseStyles = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space["2xs"],
  transitionDuration: "0.2s",
  transitionProperty: "all",
  border: vars.borders.outline,
  borderRadius: vars.radii.s,
  backgroundColor: "transparent",
  cursor: "default",
  padding: vars.space.xs,
  width: "fit-content",
  maxWidth: 200,
  height: 32,
  color: vars.colors.onSurface,
  fontFamily: "inherit",
  fontSize: vars.fontSizes.body.m,
  selectors: {
    "&[data-disabled]": {
      opacity: 0.5,
      cursor: "not-allowed",
    },
  },
});

const chipInteractiveStates = style([
  chipBaseStyles,
  {
    cursor: "pointer",
    selectors: {
      "&[data-hovered]": {
        backgroundColor: `color-mix(in srgb, ${vars.colors.bgColor}, ${vars.colors.onSurface} 2.5%)`,
      },
      "&[data-focused]": {
        backgroundColor: `color-mix(in srgb, ${vars.colors.bgColor}, ${vars.colors.onSurface} 5%)`,
      },
      "&[data-pressed]": {
        backgroundColor: `color-mix(in srgb, ${vars.colors.bgColor}, ${vars.colors.onSurface} 10%)`,
      },
      "&[data-focus-visible]": {
        outline: "auto",
      },
    },
  },
]);

export const filterChip = recipe({
  base: chipInteractiveStates,
  variants: {
    isModified: {
      true: {
        border: `1px solid ${vars.colors.onSurface}`,
      },
    },
    icon: {
      true: {
        padding: vars.space.xs,
      },
    },
  },
});

export const chevronStyles = style({
  transformOrigin: "center",
  transition: "transform 0.2s",
  selectors: {
    "[aria-expanded=true] &": {
      transform: "rotate(-180deg)",
    },
    '[dir="rtl"] &': {
      transform: "rotate(0deg)", // resetting the transform already set on the ChevronDown component via "rtlRotate180" in packages/plos/src/styles/utils.css.ts
    },
    '[dir="rtl"] [aria-expanded="true"] &': {
      transform: "rotate(180deg)",
    },
  },
});

export const chipLabelStyles = style([
  textTruncate,
  { display: "flex", alignItems: "center", gap: vars.space["2xs"] },
]);
